/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { NewPartnerLandingUiModuleFaqQuestionsBody } from './new-partner-landing-ui-module-faq-questions-body';
import { NewPartnerLandingUiModuleStepsToRedeemBody } from './new-partner-landing-ui-module-steps-to-redeem-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface NewPartnerLandingUiModuleBody
 */
export interface NewPartnerLandingUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    moduleType: NewPartnerLandingUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof NewPartnerLandingUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof NewPartnerLandingUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof NewPartnerLandingUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof NewPartnerLandingUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    subHeader?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    partnerLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    vixLogo: string;
    /**
     * 
     * @type {Array<NewPartnerLandingUiModuleStepsToRedeemBody>}
     * @memberof NewPartnerLandingUiModuleBody
     */
    stepsToRedeem?: Array<NewPartnerLandingUiModuleStepsToRedeemBody>;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    benefitsList?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    hideBenefits?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    viewBenefits?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    planName: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    planCost?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    planDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    planTier?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    legalAdsNotification?: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    selectPlanCta: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    legalDisclaimer: string;
    /**
     * 
     * @type {string}
     * @memberof NewPartnerLandingUiModuleBody
     */
    faqTitle?: string;
    /**
     * 
     * @type {Array<NewPartnerLandingUiModuleFaqQuestionsBody>}
     * @memberof NewPartnerLandingUiModuleBody
     */
    faqQuestions?: Array<NewPartnerLandingUiModuleFaqQuestionsBody>;
}

/**
    * @export
    * @enum {string}
    */
export enum NewPartnerLandingUiModuleBodyModuleTypeEnum {
    NEW_PARTNER_LANDING = 'NEW_PARTNER_LANDING'
}



